import './ReleaseCenter.less';

import { render } from 'vike/abort';

import Guarded from '@/components/Guarded';

import MessageReceiptList from './components/MessageReceiptList';

export function guard(pageContext: Vike.PageContext) {
  try {
    if (!pageContext.user) {
      throw render('/signin', "You can't access this page until after you log in.");
    }
  } catch (error) {
    console.error(error);
  }
}

export const title = 'Release Center';

// @todo use @tanstack/react-virtual
export default function Page() {
  return (
    <Guarded>
      <MessageReceiptList />
    </Guarded>
  );
}
